import { NgModule } from '@angular/core';
import { GtmGgOrderPlacedEventBuilder } from './gtm-gg-order-placed-event.builder';

declare module '@spartacus/core' {
  export interface Product {
    mainCategoryName?: string;
  }
}

@NgModule({})
export class GtmGgOrderPlacedEventModule {
  constructor(_gtmGgOrderPlacedEventBuilder: GtmGgOrderPlacedEventBuilder) {}
}
